import { c as _c } from "react/compiler-runtime";
import { useContext, useState } from 'react';
import { CONTAINER_WIDTHS, GUIDED_CONNECTION_WIDTHS } from '@hookdeck/theme';
import { Request, RequestRejectionCause } from '../../../../../../../../typings/Request.interface';
import { APISource } from '../../../../../../../../typings/Source.interface';
import LINKS from '../../../../../configs/links';
import { showChat } from '../../../../../utils/liveChat';
import { getRejectionCauseBreakdown, rejection_cause_labels } from '../../../../../utils/rejection-causes';
import Badge from '../../../../common/base/Badge';
import Button from '../../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../../common/base/Card';
import Icon from '../../../../common/base/Icon';
import Tabs from '../../../../common/base/Tabs';
import Text from '../../../../common/base/Text';
import { HeadersBlock } from '../../../../common/Data/Headers';
import DisplayDate from '../../../../common/DisplayDate';
import StyledEllipsisOverflow from '../../../../common/helpers/EllipsisOverflow';
import { Div } from '../../../../common/helpers/StyledUtils';
import JSONBrowser from '../../../../common/JSONBrowser';
import Modal from '../../../../common/Modal';
import Table from '../../../../common/Table/Table';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { RequestListResult } from '../../../../hooks/useRequestList';
import useSearchQuery from '../../../../hooks/useSearchQuery';
const retryable_rejection_causes = ['VERIFICATION_FAILED', 'UNSUPPORTED_HTTP_METHOD'] as RequestRejectionCause[];
const PreviewRequests: React.FC<{
  context: {
    source: APISource;
    requests_list: RequestListResult;
  };
  mutateContext: (context: {
    source?: APISource;
    request?: Request;
  }) => void;
  nextStep: () => void;
  is_current_step: boolean;
}> = t0 => {
  const $ = _c(41);
  const {
    context: t1,
    mutateContext,
    nextStep
  } = t0;
  const {
    source,
    requests_list
  } = t1;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  const [active_tab, setActiveTab] = useState("body");
  const {
    addToast
  } = useToasts();
  const [selected_request_id, setSelectedRequestId] = useState(null);
  let T0;
  let has_nextable_request;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== HookdeckAPI || $[1] !== active_tab || $[2] !== addToast || $[3] !== mutateContext || $[4] !== query.troubleshoot || $[5] !== requests_list?.requests || $[6] !== selected_request_id || $[7] !== source || $[8] !== updateSearchQuery) {
    const selected_request = requests_list?.requests.find(request => request.id === (selected_request_id || requests_list?.requests[0]?.id));
    let t7;
    if ($[16] !== requests_list?.requests) {
      t7 = requests_list?.requests.some(_temp) ?? false;
      $[16] = requests_list?.requests;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    has_nextable_request = t7;
    const rows = requests_list?.requests.map(request_0 => ({
      id: request_0.id,
      selected: selected_request && request_0.id === selected_request.id,
      fields: [<DisplayDate key={request_0.id} date={request_0.ingested_at} show_timezone={false} />, request_0.rejection_cause && request_0.rejection_cause !== "NO_CONNECTION" ? <Div key={request_0.id} flex={{
        justify: "space-between",
        align: "center"
      }}><Badge danger={true} subtle={true}><StyledEllipsisOverflow>{rejection_cause_labels[request_0.rejection_cause]}</StyledEllipsisOverflow></Badge>{retryable_rejection_causes.includes(request_0.rejection_cause) && <Button.Permission role="member" ghost={true} icon="retry" muted={true} small={true} onClick={e => {
          e.stopPropagation();
          HookdeckAPI.requests.retry(request_0.id).then(t8 => {
            const {
              request: updated_request
            } = t8;
            const rejected = updated_request.rejection_cause && updated_request.rejection_cause !== "NO_CONNECTION";
            addToast(rejected ? "error" : "success", rejected ? "Request retried and is still invalid" : "Request has been accepted");
            mutateContext({
              request: updated_request
            });
          });
        }} />}</Div> : <Badge success={true} subtle={true}>Accepted</Badge>]
    })) || [];
    if ($[18] !== query.troubleshoot || $[19] !== updateSearchQuery) {
      t6 = query.troubleshoot && <Modal submit_label="Help" submit_icon="chat" onSubmit={showChat} title="Request troubleshooting" onClose={() => updateSearchQuery({}, {
        remove_keys: ["troubleshoot"]
      })}><Text m={{
          b: 4
        }}>Your requests may not be showing for a variety of reasons:</Text><StyledCard p={4} m={{
          t: 4
        }}><Text bold={true} m={{
            b: 2
          }}>The sender implements a challenge to verify the Webhook URL</Text><Text muted={true}>Some webhook providers implement custom handshakes to verify the URL (also know as "Challenges"). Hookdeck will implement support for these handshakes on an ad-hoc basis when they are requested.{" "}<a href={LINKS.product_docs.inbuilt_source_support} target="_blank" rel="noreferrer">View the current list of supported platforms</a>.<br /><Button outline={true} m={{
              t: 3
            }} onClick={showChat}>Request a new one</Button></Text></StyledCard><StyledCard p={4} m={{
          t: 4
        }}><Text bold={true} m={{
            b: 2
          }}>The sender requires whitelisting our IP</Text><Text muted={true}>In some rare cases the providers might require you to whitelist Hookdeck IP's to send requests to our servers. You can whitelist Cloudflare IPs which are found{" "}<a href="http://cloudflare.com/ips/" target="_blank" rel="noreferrer">here</a>.</Text></StyledCard></Modal>;
      $[18] = query.troubleshoot;
      $[19] = updateSearchQuery;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    T0 = Div;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        gap: 6
      };
      $[21] = t2;
    } else {
      t2 = $[21];
    }
    t3 = 100;
    let t10;
    let t9;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = {
        px: GUIDED_CONNECTION_WIDTHS.step_container
      };
      t10 = {
        flexShrink: 0
      };
      $[22] = t10;
      $[23] = t9;
    } else {
      t10 = $[22];
      t9 = $[23];
    }
    const t11 = rows.length > 0 ? <StyledCardSection data-testid="guided-preview-requests-table"><Table widths={[0.5, 0.5]} headers={["Request Date", "Request Status"]} rows={rows} onRowSelected={row_id => setSelectedRequestId(row_id || null)} table_body_style={{
        overflow: "auto"
      }} table_body_h={{
        px: 355
      }} /></StyledCardSection> : <StyledCardSection muted={true} flex={{
      align: "center",
      justify: "center",
      direction: "column",
      grow: true
    }} style={{
      position: "relative"
    }} h={{
      px: 398
    }}><Icon icon="loading" m={{
        b: 4
      }} /><Text semi={true}>Waiting on your first request</Text><Text muted={true} center={true} w={{
        px: CONTAINER_WIDTHS.small
      }}>The requests you’ve triggered from your HTTP request producer will be shown here, once they arrive. You should expect to see them within 1 minute of firing the event.</Text><Div style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0
      }} flex={{
        justify: "center"
      }} m={{
        b: 4
      }}><Button ghost={true} icon="help" muted={true} on="background" onClick={() => updateSearchQuery({
          troubleshoot: true
        })}>I'm still not seeing my requests</Button></Div></StyledCardSection>;
    if ($[24] !== t11) {
      t4 = <Div w={t9} style={t10}><StyledCard overflow_hidden={true}>{t11}</StyledCard></Div>;
      $[24] = t11;
      $[25] = t4;
    } else {
      t4 = $[25];
    }
    t5 = selected_request && <StyledCard w={{
      px: GUIDED_CONNECTION_WIDTHS.details_container
    }} h={{
      px: 386
    }} flex={{
      direction: "column",
      grow: true
    }}><StyledCardSection muted={true} p={{
        y: 1,
        x: 2
      }}><Text semi={true} muted={true} size="xs">Request Details</Text></StyledCardSection>{selected_request.rejection_cause && selected_request.rejection_cause !== "NO_CONNECTION" ? <><StyledCardSection p={{
          x: 4,
          y: 3
        }}><Text semi={true} size="s" m={{
            b: 1
          }}>Error</Text><Badge danger={true} subtle={true}>{rejection_cause_labels[selected_request.rejection_cause]}</Badge></StyledCardSection><StyledCardSection p={{
          x: 4,
          y: 3
        }} flex={{
          direction: "column",
          grow: true
        }}><Text semi={true} size="s" m={{
            b: 1
          }}>Description</Text><Text size="s">{getRejectionCauseBreakdown(selected_request.rejection_cause)({
              source,
              request: selected_request,
              show_action: false
            }).text}</Text><Div m={{
            t: "auto"
          }}>{selected_request.rejection_cause === "UNSUPPORTED_HTTP_METHOD" && <Button outline={true} onClick={() => HookdeckAPI.sources.update(source.id, {
              allowed_http_methods: Array.from(new Set([...(source.config.allowed_http_methods as string[]), selected_request.data?.headers["x-hookdeck-original-method"] || "POST"]))
            }).then(source_0 => {
              HookdeckAPI.requests.retry(selected_request.id).then(t12 => {
                const {
                  request: updated_request_0
                } = t12;
                addToast("success", "Method enabled and request retried successfully");
                mutateContext({
                  request: updated_request_0
                });
              });
              mutateContext({
                source: source_0
              });
            })}>Enable{" "}{selected_request.data?.headers["x-hookdeck-original-method"]?.toUpperCase() || "POST"}</Button>}{selected_request.rejection_cause === "VERIFICATION_FAILED" && <Button outline={true} onClick={() => HookdeckAPI.sources.update(source.id, {
              ...source,
              config: {
                ...source.config,
                auth: null,
                auth_type: null
              }
            }).then(source_1 => {
              HookdeckAPI.requests.retry(selected_request.id).then(t13 => {
                const {
                  request: updated_request_1
                } = t13;
                addToast("success", "Authentication removed and request retried successfully");
                mutateContext({
                  request: updated_request_1
                });
              });
              mutateContext({
                source: source_1
              });
            })}>Disable authentication</Button>}</Div></StyledCardSection></> : <><StyledCardSection muted={true} p={{
          t: 1.5,
          x: 2
        }}><Tabs compact={true} border={false} active_tab={active_tab} onTabSelected={key => setActiveTab(key)} tabs={[{
            key: "body",
            label: "Body"
          }, {
            key: "headers",
            label: "Headers"
          }]} /></StyledCardSection>{active_tab === "body" && <StyledCardSection muted={true} scroll={true} p={4} flex={{
          grow: true,
          direction: "column"
        }}><JSONBrowser json={selected_request.data?.body || null} compact={true} /></StyledCardSection>}{active_tab === "headers" && <StyledCardSection muted={true} p={4} flex={{
          grow: true,
          direction: "column"
        }} style={{
          overflow: "auto"
        }}><HeadersBlock headers={selected_request.data?.headers || {}} search_value="" /></StyledCardSection>}</>}</StyledCard>;
    $[0] = HookdeckAPI;
    $[1] = active_tab;
    $[2] = addToast;
    $[3] = mutateContext;
    $[4] = query.troubleshoot;
    $[5] = requests_list?.requests;
    $[6] = selected_request_id;
    $[7] = source;
    $[8] = updateSearchQuery;
    $[9] = T0;
    $[10] = has_nextable_request;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    T0 = $[9];
    has_nextable_request = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
  }
  let t7;
  if ($[26] !== T0 || $[27] !== t2 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5) {
    t7 = <T0 flex={t2} w={t3}>{t4}{t5}</T0>;
    $[26] = T0;
    $[27] = t2;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      gap: 3
    };
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  let t9;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      t: 8
    };
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  const t10 = !has_nextable_request;
  let t11;
  if ($[34] !== nextStep || $[35] !== t10) {
    t11 = <Div flex={t8}><Button data-testid="guided-preview-requests-next" m={t9} onClick={nextStep} outline={true} disabled={t10}>Next</Button></Div>;
    $[34] = nextStep;
    $[35] = t10;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== t11 || $[38] !== t6 || $[39] !== t7) {
    t12 = <>{t6}{t7}{t11}</>;
    $[37] = t11;
    $[38] = t6;
    $[39] = t7;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  return t12;
};
export default PreviewRequests;
function _temp(model) {
  return !model.rejection_cause || model.rejection_cause === "NO_CONNECTION";
}